module.exports = __webpack_public_path__ + "img/whyRed.bd20ee09.jpg";